import {castArray} from '@coolcolduk/util';
import {useCallback, useState} from 'react';
import type {Job} from '@cp/model';
import {jobCreateQuestionGeneration} from '../../api/callable/jobs';

export function useCreateQuestionGenerationJob() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const createQuestionGenerationJob = useCallback(
    async (moduleId: string, topics: string[], difficulties?: number | number[], count?: number): Promise<Job> => {
      setLoading(true);
      setError(undefined);
      try {
        return await jobCreateQuestionGeneration({
          moduleId,
          topics,
          difficulties: difficulties !== undefined ? castArray(difficulties) : undefined,
          count,
        });
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    createQuestionGenerationJob,
    loading,
    error,
  };
}
